// import { Box, Text, theme } from "@aksara-ui/react";
import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import UltraRewardsContent from "modules/UltraRewards";
import React from "react";

import { setTitle } from "utilities/helper/setTitle";
const UltraRewardPage: React.FC = () => {
  setTitle("Ultra Reward");
  return (
    <Auth>
      <Layout>
        <UltraRewardsContent />
      </Layout>
    </Auth>
  );
};

export default UltraRewardPage;
